import { getClient } from '@zg-rentals/ts-client-http-client';

export const rentalClient = getClient().extend({ prefixUrl: process.env.NEXT_PUBLIC_SET_CLIENT_PREFIX_URL });
